import styled from 'styled-components'
import { skeletonAnimation } from 'src/styles'

export const Wrapper = styled.div`
  margin: 0 1.875rem;
`

Wrapper.displayName = 'Wrapper'

export const Title = styled.div`
  width: 60%;
  height: 1.1875rem;
  ${skeletonAnimation}
`

Title.displayName = 'Title'

export const Text = styled.div`
  width: 100%;
  height: 0.75rem;
  ${skeletonAnimation}
`

Text.displayName = 'Text'

export const ProgressText = styled.div`
  width: 40%;
  height: 0.625rem;
  ${skeletonAnimation}
`

ProgressText.displayName = 'ProgressText'

export const ProgressBar = styled.div`
  width: 100%;
  height: 0.625rem;
  ${skeletonAnimation}
`

ProgressBar.displayName = 'ProgressBar'
